import { createContext, useReducer } from 'react';

const initialState = {
  environment: undefined,
  dynamicGridParam: {}, // store for multiple dynamic grids params grouped by dynamic grid's queryTagsKey
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_ENVIRONMENT':
      return {
        ...state,
        environment: action.payload,
      };
    //set a dynamic grid params based on its queryTagsKey (ex. dynamicGridParam.recipe_grid )
    case 'SET_DYNAMIC_GRID_PARAMS':
      return {
        ...state,
        dynamicGridParam: {
          ...state.dynamicGridParam,
          [action.payload.queryTagsKey]: {
            ...state.dynamicGridParam[action.payload.queryTagsKey],
            ...(action.payload.queryTagIds && {
              queryTagIds: action.payload.queryTagIds,
            }),
            ...(action.payload.paginationNo && {
              paginationNo: action.payload.paginationNo,
            }),
            ...(action.payload.paginationLimit && {
              paginationLimit: action.payload.paginationLimit,
            }),
            ...(action.payload.isFiltering !== undefined && {
              isFiltering: action.payload.isFiltering,
            }),
            ...(action.payload.filterParams !== undefined && {
              filterParams: action.payload.filterParams,
            }),
            offset: action.payload.offset,
          },
        },
      };
  }
};

const StateContext = createContext(initialState);
const DispatchContext = createContext(() => {});

const ContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>{children}</StateContext.Provider>
    </DispatchContext.Provider>
  );
};

export { StateContext, DispatchContext, ContextProvider };
